import config from '@config/index';
import {EmbedType} from '@constants/embedType';

const FULL_STYLE_NAME = 'style.css';
const MIN_STYLE_NAME = 'global.css';

export function loadCPScript(callback?: () => void): void {
    loadScript('cp-widget', 'https://widget.cloudpayments.ru/bundles/cloudpayments.js', callback);
}

export function loadPSScript(callback?: () => void): void {
    loadScript('ps-widget', 'https://widget.payselection.com/lib/pay-widget.js', callback);
}

export function loadTezScript(callback?: () => void): void {
    loadScript('tez-widget', `https://cdn.oplatazakaza.com/widget-js/pbwidget.js?${(new Date()).getTime()}`, callback);
}

function loadScript(id: string, url: string, callback?: () => void): void {
    const existingScript = document.getElementById(id);
    if (!existingScript) {
        const script = document.createElement('script');
        script.src = url;
        script.id = id;
        document.body.appendChild(script);
        script.onload = () => {
            if (callback) {
                callback();
            }
        };
    }

    if (existingScript && callback) {
        callback();
    }
}

export function loadStyles(embedType: EmbedType): void {
    const url = new URL((document.currentScript as HTMLScriptElement).src);
    const styleName = isMinStyleRequired(embedType) ? MIN_STYLE_NAME : FULL_STYLE_NAME;

    const existingLink = document.getElementById('ps-styles');
    if (!existingLink) {
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = `${url.origin}/${styleName}?v=${config.version}`;
        link.id = 'ps-styles';
        link.type = 'text/css';
        link.media = 'all';
        document.head.appendChild(link);
    }
}

function isMinStyleRequired(embedType: EmbedType): boolean {
    return embedType === EmbedType.VpnCardChange;
}
